/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, Text, Theme, useTheme, VFlow } from 'bold-ui'

import { PassouFalhouEnum } from '../model-consultaSeguimento'
import { ConsultaSeguimentoPinDown } from './ConsultaSeguimentoPinDown'

interface ConsultaSeguimentoIndicatorResultadoProps {
  text?: Partial<Record<PassouFalhouEnum, string>>
  resultado: PassouFalhouEnum
}

export function ConsultaSeguimentoIndicatorResultado(props: Readonly<ConsultaSeguimentoIndicatorResultadoProps>) {
  const { text, resultado } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={[styles.root]}>
      <ConsultaSeguimentoPinDown style={[styles.pin, styles.pinStatus[resultado]]} />
      <VFlow vSpacing={0} style={[styles.box, styles.boxStatus[resultado]]}>
        {text?.[resultado] && <Text color='inherit'>{text[resultado]}</Text>}
        <Heading level={3} color='inherit'>
          {resultado === PassouFalhouEnum.PASSOU ? 'Passou' : 'Falhou'}
        </Heading>
      </VFlow>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    display: grid;
    justify-self: center;
    justify-items: center;
  `,
  pin: css`
    transform: translateZ(0);
  `,
  pinStatus: {
    [PassouFalhouEnum.PASSOU]: css`
      color: ${theme.pallete.status.success.c60};
    `,
    [PassouFalhouEnum.FALHOU]: css`
      color: ${theme.pallete.status.danger.c60};
    `,
  },
  box: css`
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    margin-top: -0.325rem;
  `,
  boxStatus: {
    [PassouFalhouEnum.PASSOU]: css`
      color: ${theme.pallete.status.success.c40};
      background: ${theme.pallete.status.success.c90};
    `,
    [PassouFalhouEnum.FALHOU]: css`
      background: ${theme.pallete.status.danger.c90};
      color: ${theme.pallete.status.danger.c40};
    `,
  },
})
